module.exports = __webpack_public_path__ + "img/icons8-new-ticket-100 1 copy.a5c3c256.svg";